'use strict';

// TODO: remove, semver-major

module.exports = require('get-intrinsic');



/*****************
 ** WEBPACK FOOTER
 ** ./~/es-abstract/GetIntrinsic.js
 ** module id = 931
 ** module chunks = 0
 **/